import { RefObject, useEffect, useRef, useState } from "react";
import { Mail, MessageCircle } from "lucide-react";

interface FloatingCTAProps {
  onContactClick: () => void;
  onConsultClick: () => void;
  hideWhenVisible?: boolean;
  targetRef: RefObject<Element | null>;
}

export default function FloatingCTA({
  onContactClick,
  onConsultClick,
  hideWhenVisible = true,
  targetRef
}: FloatingCTAProps) {
  const [isVisible, setIsVisible] = useState<boolean>(true);
  const observerRef = useRef<IntersectionObserver | null>(null);

  useEffect(() => {
  const target = targetRef.current;
  if (!target) return;

  observerRef.current = new IntersectionObserver(
    ([entry]) => {
      if (hideWhenVisible) {
        setIsVisible(!entry.isIntersecting);
      }
    },
    {
      threshold: 0,
    }
  );

  observerRef.current.observe(target);

  return () => observerRef.current?.disconnect();
}, [hideWhenVisible, targetRef]);


  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 z-[90] right-6 flex flex-col gap-3 right-[max(1.5rem,calc((100vw-1440px)/2+1.5rem))]">
      {/* Contact */}
      <button
        onClick={onContactClick}
        aria-label="Contact us"
        className="
          flex h-12 w-12 items-center justify-center
          rounded-full bg-blue-700 text-white shadow-lg
          transition-all duration-200
          hover:-translate-y-1 hover:bg-blue-800
        "
      >
        <Mail size={20} />
      </button>

      {/* Consultation */}
      <button
        onClick={onConsultClick}
        aria-label="Request consultation"
        className="
          flex h-12 w-12 items-center justify-center
          rounded-full bg-white text-blue-700 shadow-lg
          ring-1 ring-blue-700
          transition-all duration-200
          hover:-translate-y-1 hover:bg-blue-50
        "
      >
        <MessageCircle size={20} />
      </button>
    </div>
  );
}
